<script>
import bannerV1 from './v1/index.vue'
import bannerV2 from './v2/index.vue'
export default {
  components: {
    bannerV1,
    bannerV2
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return { version: '1' }
      }
    }
  },
  methods: {
    play () {
      this.$emit('play')
    }
  },
  render () {
    const Tag = `banner-v${this.data.version}`
    return (<Tag {...{ on: { play: this.play } }}></Tag>)
  }
}

</script>
